import { AttendanceStatus } from "../../../Utilities";

export function color(
	attendanceStatus: Pick<
		AttendanceStatus,
		"indicatesAbsent" | "indicatesLateArrival" | "indicatesEarlyDeparture" | "indicatesExcused"
	> | null,
) {
	if (!attendanceStatus) {
		return "var(--neutral-colors--tertiary)";
	}
	if (attendanceStatus.indicatesExcused) {
		return "var(--theme-colors__blue)";
	}
	if (attendanceStatus.indicatesAbsent) {
		return "var(--theme-colors__pink)";
	}
	if (attendanceStatus.indicatesLateArrival || attendanceStatus.indicatesEarlyDeparture) {
		return "var(--theme-colors__yellow)";
	}
	return "var(--theme-colors__green)";
}

export function backgroundColor(
	attendanceStatus: Pick<
		AttendanceStatus,
		"indicatesAbsent" | "indicatesLateArrival" | "indicatesEarlyDeparture" | "indicatesExcused"
	> | null,
) {
	if (!attendanceStatus) {
		return "var(--neutral-colors--light)";
	}
	if (attendanceStatus.indicatesExcused) {
		return "var(--theme-colors__blue--background)";
	}
	if (attendanceStatus.indicatesAbsent) {
		return "var(--theme-colors__pink--background)";
	}
	if (attendanceStatus.indicatesLateArrival || attendanceStatus.indicatesEarlyDeparture) {
		return "var(--theme-colors__yellow--background)";
	}
	return "var(--theme-colors__green--background)";
}

export function isPresent(attendanceStatus: Pick<AttendanceStatus, "indicatesAbsent">) {
	return !attendanceStatus.indicatesAbsent;
}
